export default function Marquee({ items, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#F7F8FA] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#F7F8FA] to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-14 py-1">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-14 whitespace-nowrap text-sm font-semibold uppercase tracking-[0.22em] text-[#6B7280]"
          >
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-[#1677FF]" />
          </span>
        ))}
      </div>
    </div>
  );
}
